import React from 'react';

import ConnectedModal from 'components/ConnectedModal';
import { useModalParams } from 'state/modal';

import CreateAudiogramModalContents from './CreateAudiogramModalContents';

const CreateAudiogramModal: React.FunctionComponent = () => {
  const params = useModalParams('CreateAudiogram');

  return (
    <ConnectedModal name="CreateAudiogram">
      <CreateAudiogramModalContents params={params} />
    </ConnectedModal>
  );
};

export default CreateAudiogramModal;
